import { useEffect, useRef } from 'react';

export function useDebouncedCallback<A extends any[]>(
  callback: (...args: A) => void,
  delay: number,
) {
  // Stores the latest arguments to use when calling the callback
  const argsRef = useRef<A | undefined>(undefined);
  const timeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  // Provide a means to cancel the debounced execution
  const allowExecution = useRef(true);

  function cleanup() {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }
  useEffect(() => cleanup, []);

  return {
    debouncedCallback: function debouncedCallback(...args: A) {
      // any subsequent call to the debounced callback will revert the cancel
      allowExecution.current = true;
      argsRef.current = args;
      cleanup();
      timeout.current = setTimeout(() => {
        if (argsRef.current && allowExecution.current) {
          callback(...argsRef.current);
        }
      }, delay);
    },
    cancel: function () {
      allowExecution.current = false;
    },
  };
}
